import { render, staticRenderFns } from "./ChannelOutcomesDialog.vue?vue&type=template&id=e7b1179c"
import script from "./ChannelOutcomesDialog.vue?vue&type=script&lang=js"
export * from "./ChannelOutcomesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports